import { Link } from 'react-router-dom';
import MentorPortalService from './MentorPortalService';
import { MentorConversationRow } from './MentorMessagesService';
import { formatDayMonthYear } from './mentorDashboardFormat';

type Props = {
    conversations: MentorConversationRow[];
};

const MentorRecentMessagesWidget = ({ conversations }: Props) => {
    const withPreview = conversations
        .filter((row) => row.lastMessagePreview)
        .sort((a, b) => {
            const aTime = a.lastSentDate ? Date.parse(a.lastSentDate) : 0;
            const bTime = b.lastSentDate ? Date.parse(b.lastSentDate) : 0;
            return bTime - aTime;
        })
        .slice(0, 3);

    return (
        <div className="col-lg-6" aria-label="Recent messages">
            <div className='card border-0 shadow-sm rounded-3 bg-white h-100'>
                <div className="card-header bg-white border-bottom border-light-subtle p-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0 text-dark">Recent Messages</h6>
                    <Link to={MentorPortalService.messagesHref()} className="btn btn-link text-primary p-0 font-12 fw-bold text-decoration-none">
                        Open inbox →
                    </Link>
                </div>
                {withPreview.length === 0 ? (
                <div className="mdash-empty p-3 mb-0">No messages yet.</div>
            ) : (
                <div className="list-group list-group-flush">
                    {withPreview.map((row) => {
                        const uuid = row.mentee.menteeUuid;
                        const key = uuid || String(row.mentee.pairId ?? row.mentee.menteeName);
                        return (
                            
                                <Link to={MentorPortalService.messagesHref(uuid)} className="list-group-item list-group-item-action d-flex gap-3 p-3 bg-primary bg-opacity-10 border-0 border-bottom border-light-subtle position-relative" key={key}>
                                    <svg width="36" height="36" className="rounded-circle border border-primary border-opacity-25 flex-shrink-0">
                                        <rect width="100%" height="100%" fill="#EDE9FE"></rect>
                                        <text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" fill="#8B5CF6" font-size="13" font-weight="bold" font-family="Outfit">AM</text>
                                    </svg>
                                    <div className="flex-grow-1">
                                        <div className="d-flex justify-content-between align-items-center">
                                        <div className="fw-bold font-13 text-dark">{row.mentee.menteeName || 'Mentee'}</div>
                                        {row.lastSentDate ? (
                                        <div className="text-muted font-11 d-flex align-items-center gap-2">
                                            {formatDayMonthYear(row.lastSentDate)} <i className="p-1 bg-danger rounded-circle"><span className="visually-hidden">New message</span></i>
                                        </div>
                                    ) : null}
                                        </div>
                                        <div className="text-secondary small mt-1 font-12 text-truncate"  style={{maxWidth:'280px'}}>{row.lastMessagePreview}</div>
                                    </div>
                                    <span className="mdash-recent-msg-name"></span>
                                    <span className="mdash-recent-msg-preview"></span>
                                    
                                </Link>
                            
                        );
                    })}
                </div>
            )}
            </div>
            
            
        </div>
    );
};

export default MentorRecentMessagesWidget;
